/** @file PadletSpeechBubbleShape schema */
import {
  createShapePropsMigrationIds,
  createShapePropsMigrationSequence,
  defaultColorNames,
  DefaultColorStyle,
  DefaultDashStyle,
  DefaultFillStyle,
  DefaultFontStyle,
  DefaultHorizontalAlignStyle,
  DefaultSizeStyle,
  DefaultVerticalAlignStyle,
  richTextValidator,
  StyleProp,
  T,
  TLBaseShape,
  TLDefaultColorStyle,
  TLDefaultDashStyle,
  TLDefaultFillStyle,
  TLDefaultFontStyle,
  TLDefaultHorizontalAlignStyle,
  TLDefaultSizeStyle,
  TLDefaultVerticalAlignStyle,
  TLRichText,
  toRichText,
  VecModel,
  vecModelValidator,
} from 'tldraw'

// https://github.com/tldraw/tldraw/blob/579166a0e092a5ba49df40b684173e81f359751b/packages/tlschema/src/styles/TLColorStyle.ts#L444
const DefaultLabelColorStyle = StyleProp.defineEnum('tldraw:padletSpeechBubbleLabelColor', {
  defaultValue: 'black',
  values: defaultColorNames,
})

// Similar to geoShapeProps
// https://github.com/tldraw/tldraw/blob/579166a0e092a5ba49df40b684173e81f359751b/packages/tlschema/src/shapes/TLGeoShape.ts#L77C14-L77C27
const padletSpeechBubbleShapeProps = {
  w: T.nonZeroNumber,
  h: T.nonZeroNumber,
  color: DefaultColorStyle,
  labelColor: DefaultLabelColorStyle,
  size: DefaultSizeStyle,
  font: DefaultFontStyle,
  align: DefaultHorizontalAlignStyle,
  verticalAlign: DefaultVerticalAlignStyle,
  growY: T.positiveNumber,
  richText: richTextValidator,
  tail: vecModelValidator,
  fill: DefaultFillStyle,
  url: T.linkUrl,
  scale: T.nonZeroNumber,
  dash: DefaultDashStyle,
}

// Similar to TLGeoShapeProps
// https://github.com/tldraw/tldraw/blob/579166a0e092a5ba49df40b684173e81f359751b/packages/tlschema/src/shapes/TLGeoShape.ts
interface PadletSpeechBubbleShapeProps {
  w: number
  h: number
  color: TLDefaultColorStyle
  labelColor: TLDefaultColorStyle
  size: TLDefaultSizeStyle
  font: TLDefaultFontStyle
  align: TLDefaultHorizontalAlignStyle
  verticalAlign: TLDefaultVerticalAlignStyle
  growY: number
  richText: TLRichText
  tail: VecModel
  fill: TLDefaultFillStyle
  url: string
  scale: number
  dash: TLDefaultDashStyle
}

type PadletSpeechBubbleShape = TLBaseShape<'padlet-speech-bubble', PadletSpeechBubbleShapeProps>

const padletSpeechBubbleShapeVersions = createShapePropsMigrationIds('padlet-speech-bubble', {
  AddRichText: 1,
})

const padletSpeechBubbleShapeMigrations = createShapePropsMigrationSequence({
  sequence: [
    {
      id: padletSpeechBubbleShapeVersions.AddRichText,
      up: (props) => {
        if ('text' in props) {
          props.richText = toRichText(props.text as string)
          delete props.text
        }
      },
      down: (props) => {
        // No-op, explicitly no down state so that we force clients to update.
        // delete props.richText
      },
    },
  ],
})

export {
  PadletSpeechBubbleShape,
  padletSpeechBubbleShapeMigrations,
  PadletSpeechBubbleShapeProps,
  padletSpeechBubbleShapeProps,
  padletSpeechBubbleShapeVersions,
}
